var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTonkeeper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M13.1348 12.2777L24.6904 7.04169L13.1348 25.2777V12.2777Z",
    fill: "#45AEF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.1357 12.2777L1.58008 7.04169L13.1357 25.2777V12.2777Z",
    fill: "#45AEF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1357 12.2777L1.58008 7.04169L13.1357 1.80566L24.6914 7.04169L13.1357 12.2777Z",
    fill: "#45AEF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonkeeper);
export default __webpack_public_path__ + "static/media/tonkeeper.67dd6e46d54c6bfc7cd69da2c5a3c465.svg";
export { ForwardRef as ReactComponent };